<template>
  <ToolbarItemContainer ref="container" :iconFile="wordsIcon" title="常用语" :needBottomPopup="true" :iconWidth="0"
    :iconHeight="0" @onDialogShow="onDialogShow" @onDialogClose="onDialogClose">
    <div :class="['words', !isPC && 'words-h5']">
      <div :class="['words-header', !isPC && 'words-h5-header']">
        <!-- <span :class="['words-header-title', !isPC && 'words-h5-header-title']" style="color: #000;">快捷语-点击选择快捷语</span> -->
        <span v-if="!isPC" :class="['words-header-close', !isPC && 'words-h5-header-close']" @click="closeDialog">
          关闭
        </span>
      </div>
      <div :class="['words-list', !isPC && 'words-h5-list']">
        <ul>
          <li v-for="(item, index) in wordsList" :key="index"
            :class="['words-list-item', !isPC && 'words-h5-list-item']" @click="selectWord(item.phrasesContent)">
            <div class="words-list-item-content">
              <div class="group-name">{{ item.phrasesName }}</div>
              <div class="content">{{ item.phrasesContent }}</div>
            </div>
          </li>
        </ul>
      </div>
      <div class="footer" style="border-top: 1px solid #eee;padding-top: 5px;">
        <pagination v-if="wordsList.length" v-model:current-page="currentPage" v-model:page-size="pageSize"
          :total="total" :page-sizes="[15, 25, 35, 50]" layout="total, prev, pager, next" :background="true"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        <div class="close-dialog-btn" @click="quickLanguage.hide()">关闭</div>
      </div>
    </div>
  </ToolbarItemContainer>
</template>
<script setup lang="ts">
import {
  TUITranslateService,
  TUIStore,
  StoreName,
  IConversationModel,
  SendMessageParams,
  TUIChatService,
} from '@tencentcloud/chat-uikit-engine';
import { ref, watchEffect } from '../../../../adapter-vue';
import ToolbarItemContainer from '../toolbar-item-container/index.vue';
import wordsIconLight from '../../../../assets/icon/words-light.svg';
import wordsIconDark from '../../../../assets/icon/words-dark.svg';
// import { wordsList } from '../../utils/wordsList';
import { isEnabledMessageReadReceiptGlobal } from '../../utils/utils';
import { isPC, isUniFrameWork } from '../../../../utils/env';
import TUIChatConfig from '../../config';
import quickLanguageStore from '@/store/modules/quickLanguage'
import { searchQuickWordsApi } from '@/utils/user';
import pagination from '@/TUIKit/components/common/Pagination/index.vue'


const currentPage = ref(1); // 当前页码
const pageSize = ref(12); // 每页显示的数量
const total = ref(0); // 总数量
const wordsList: any = ref([])

// 快捷语仓库
const quickLanguage = quickLanguageStore()

// 获取单词列表
const getWordsList = async () => {
  const res = await searchQuickWordsApi({ name: quickLanguage.currentText, pageSize: pageSize.value, pageNum: currentPage.value })
  wordsList.value = res.body?.list
  total.value = res.body?.count || 0;
}

const handleCurrentChange = (val: number) => {
  currentPage.value = val;
  getWordsList();
}


const wordsIcon = TUIChatConfig.getTheme() === 'dark' ? wordsIconDark : wordsIconLight;
const emits = defineEmits(['onDialogPopupShowOrHide']);
const currentConversation = ref<IConversationModel>();
const container = ref();

TUIStore.watch(StoreName.CONV, {
  currentConversation: (conversation: IConversationModel) => {
    currentConversation.value = conversation;
  },
});

watchEffect(() => {
  if (quickLanguage.show) {
    container?.value?.toggleDialogDisplay(true);
    wordsList.value = [...quickLanguage.contentList]
    total.value = quickLanguage.total
  } else {
    container?.value?.toggleDialogDisplay(false);
  }
})

// 选择快捷语后，把快捷语内容设置到pinia中，并隐藏快捷语弹窗
const selectWord = (selectWord: any) => {
  quickLanguage.setQuickLanguageText('') //先清空，防止监听不到
  quickLanguage.setQuickLanguageText(selectWord)
  quickLanguage.hide()
};

const closeDialog = () => {
  container?.value?.toggleDialogDisplay(false);
};

const onDialogShow = () => {
  emits('onDialogPopupShowOrHide', true);
};

const onDialogClose = () => {
  emits('onDialogPopupShowOrHide', false);
};
</script>
<style scoped lang="scss" src="./style/index.scss"></style>
<style scoped lang="scss">
.words {
  width: 40vw;
  height: auto;

  .words-list {
    min-height: 200px;

    .words-list-item {
      width: 100%;
      padding: 4px 0;

      .words-list-item-content {
        display: flex;
        color: #1e1e1e;

        .group-name {
          width: 130px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #999999;
        }

        .content {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        &:hover{
          color: #3d5eff;
        }
      }
    }
  }

  .footer {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;

    .close-dialog-btn {
      color: navy;
      font-weight: 500;
      font-size: 13px;
      cursor: pointer;
    }
  }
}
</style>